import { isTest } from "./isTest";

export function timelog(...args) {
  if (!isTest()) return;

  console.log((new Date()).toLocaleTimeString(), ...args)
}
